import {
  capitalize,
  Grid,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { EarnestAndCommissions } from './components/EarnestAndCommissions/index';
import React, { FC } from 'react';
import { Control } from 'react-hook-form';
import { OrderProperty } from 'types/order';
import { REFINANCE, LEDGER_CODE_PURCHASE_PRICE } from 'utils/constants';
import { AccountingType } from 'v2-types/order';
import { AddAndUpdatePartyLedgerEntry } from '../../../../../components/add-and-update-party-ledger-modal/add-and-update-party-ledger-entry';
import { PropertyNumberField } from '../PropertyNumberField';
import { useTabAmountHooks } from './tab-amount-hooks';
import { Loans } from './components/Loans';
import { MortgagePayoff } from './components/MortgagePayoff';
import { TaxesAndProrations } from './components/TaxesAndProrations';

const useStyles = makeStyles((theme: any) => ({
  container: { marginTop: theme.spacing(2), marginBottom: theme.spacing(2) },
  fullWidth: {
    [theme.breakpoints.down('md')]: { width: '100%' },
  },
}));

type TabAmountsProps = {
  propertyId: string,
  control: Control<Omit<OrderProperty, 'loans'>>,
  selectedProperty: OrderProperty,
  transactionType: string
};

export const TabAmounts: FC<TabAmountsProps> = ({
  propertyId,
  control,
  selectedProperty,
  transactionType
}) => {
  const classes = useStyles();

  const {
    orderId,
    accountingEntries,
    purchasePriceEntries,
    openPartyLedgerModal,
    setOpenPartyLedgerModal,
    entryLedger,
    partyLedgerEntry,
    setPartyLedgerEntry,
    onUpdatePurchasePriceEntries,
    onRemoveOrderPartyEntry,
    t,
  } = useTabAmountHooks({ control });

  return (
    <Grid container spacing={3} className={`${classes.container} ${classes.fullWidth}`} direction="column">
      <Grid item xs container spacing={2}>
        {accountingEntries.filter((entry) => {
          const { code } = entry as AccountingType;
          if (code.includes(LEDGER_CODE_PURCHASE_PRICE) && transactionType === REFINANCE) return false;

          return true;
        }).map((entry, index) => {
          const { code } = entry as AccountingType;
          const label = capitalize(code.replace(`_${propertyId}`, '').replace('_', ' '));

          return (
            <Grid item xs key={entry.id}>
              <PropertyNumberField
                control={control}
                name={`accounting.${index}.amount`}
                label={label}
                decimalScale={2}
                thousandSeparator
                prefix="$"
                isMoney
              />
            </Grid>
          );
        })}
      </Grid>
      {transactionType !== REFINANCE && (
        <EarnestAndCommissions
          purchasePriceEntries={purchasePriceEntries}
          onRemoveOrderPartyEntry={onRemoveOrderPartyEntry}
          setOpenPartyLedgerModal={setOpenPartyLedgerModal}
          setPartyLedgerEntry={setPartyLedgerEntry}
          t={t}
        />
      )}
      <Loans
        orderId={orderId}
        selectedProperty={selectedProperty}
        t={t}
      />
      <MortgagePayoff
        orderId={orderId}
        selectedProperty={selectedProperty}
        t={t}
      />
      <TaxesAndProrations
        orderId={orderId}
        selectedProperty={selectedProperty}
        t={t}
      />

      {entryLedger && openPartyLedgerModal && (
        <AddAndUpdatePartyLedgerEntry
          kindAllowedAssociationList={['earnest', 'commission', 'option', 'owner']}
          entryLedger={entryLedger}
          partyLedgerEntry={partyLedgerEntry}
          handleClose={() => {
            setPartyLedgerEntry(undefined);
            setOpenPartyLedgerModal(false);
          }}
          handleSuccess={onUpdatePurchasePriceEntries}
        />
      )}
    </Grid>
  );
};
